import { motion } from "framer-motion";
import { Star, ShieldCheck, Zap, Users } from "lucide-react";

const badges = [
  { icon: Star, label: "5.0", sub: "Avg. Client Rating" },
  { icon: Users, label: "12+", sub: "Websites Shipped" },
  { icon: Zap, label: "<7d", sub: "MVP Turnaround" },
  { icon: ShieldCheck, label: "1yr", sub: "Free Bug Support" },
];

export default function TrustBadges() {
  return (
    <motion.div
      data-testid="trust-badges"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-40px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: 0.09 } },
      }}
      className="mt-14 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-3 lg:gap-4 max-w-4xl"
    >
      {badges.map((b) => (
        <motion.div
          key={b.sub}
          variants={{
            hidden: { opacity: 0, y: 14 },
            show: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] },
            },
          }}
          className="group relative p-4 lg:p-5 rounded-2xl border border-white/10 bg-[#0C0C0C]/70 backdrop-blur hover:border-[#E2FF31]/40 hover:bg-[#E2FF31]/[0.04] transition-all"
        >
          <b.icon
            size={16}
            className="text-[#E2FF31] mb-2 group-hover:rotate-[-8deg] transition-transform"
          />
          <div className="font-display text-2xl lg:text-3xl font-medium tracking-tight">
            {b.label}
          </div>
          <div className="mt-1 font-mono-tag text-[9px] text-white/50">
            {b.sub}
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
}
